export default __webpack_public_path__ + "static/media/man-with-cloud-en.e1f56489.png";